import { XIcon } from '@adornis/chemistry/elements/components/x-icon.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import 'https://fonts.googleapis.com/icon?family=Material+Icons';

import { customElement } from 'lit/decorators.js';

@customElement('tr-icon')
export class TrIcon extends XIcon {
  override styles() {
    return [
      ...super.styles(),
      {
        '&[white]': {
          color: '#fff',
        },
        '&[lighten-warning]': {
          color: DesignSystem.currentTheme.value.colors.tone.warning?.shade(50),
        },
        '&[pointer]': {
          cursor: 'pointer',
        },
        '&[huge]': {
          fontSize: '26px',
        },
        '&[big]': {
          fontSize: '20px',
        },
        '&[medium]': {
          fontSize: '18px',
        },
        '&[small]': {
          fontSize: '14px',
        },
      },
    ];
  }
}
